import loadable from '@loadable/component';

import './Agb.css';

export default loadable(() => {
  return import('./Agb.jsx');
});
